export default "__VITE_ASSET__nZo3SZ7N__"